import { css } from '@emotion/react';
import { TYPOGRAPHY_PRESETS } from '../../../styles';
import { focusOutlineCss } from '../../../styles/mixins/focus';
import { hoverTransition } from '../mixins';

/**
 * Base styles shared across primary/secondary/tertiary button atoms.
 */
export const buttonBaseCss = /*#__PURE__*/css("width:fit-content;border-radius:var(--classy-border__radius-md);&:hover{transition:background,color ", hoverTransition, ";}&:focus{", focusOutlineCss, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:buttonBaseCss;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * Common button sizes.
 * Used to size the button and icon.
 */

/**
 * Per Figma:
 * https://www.figma.com/file/ppvpPegXOdvLLpuHxOiIRn/Donor-facing-pages-UI-kit?node-id=6397%3A24587&mode=dev
 *
 * * Overriding line height is deliberate, per design, to ensure expected button heights.
 * * Since the line height is the same across presets, the initial thought is to move it to
 * * buttonBaseCss, but then it would be overridden by the typography preset applied by the size
 * * preset. Therefore, it has to be included in the size preset in all its duplicated glory.
 */
export const BUTTON_SIZE_PRESETS = {
  lg: {
    padding: '16px 24px',
    ...TYPOGRAPHY_PRESETS.classyParagraphLgBold,
    lineHeight: 1,
    minHeight: '56px'
  },
  md: {
    padding: '12px 24px',
    ...TYPOGRAPHY_PRESETS.classyParagraphSmBold,
    lineHeight: 1,
    minHeight: '48px'
  },
  sm: {
    padding: '8px 16px',
    ...TYPOGRAPHY_PRESETS.classyParagraphSmBold,
    lineHeight: 1,
    minHeight: '32px'
  }
};

/**
 * Per Figma:
 * https://www.figma.com/file/ppvpPegXOdvLLpuHxOiIRn/Donor-facing-pages-UI-kit?node-id=6397%3A24587&mode=dev
 */
export const ICON_SIZE_PRESETS = {
  lg: {
    height: '24px',
    width: '24px'
  },
  md: {
    height: '16px',
    width: '16px'
  },
  sm: {
    height: '16px',
    width: '16px'
  }
};